import { ColumnKey } from '../table-config';

export enum ScreenNameEnums {
  PRODUCT_LIST = 'PRODUCT_LIST',
  SCHEME_LIST = 'SCHEME_LIST',
  CUSTOMER_LIST = 'CUSTOMER_LIST',
  ORDER_LIST = 'ORDER_LIST',
  ORDER_DETAILS = 'ORDER_DETAILS',
  INVOICE_LIST = 'INVOICE_LIST',
  INVOICE_DETAILS = 'INVOICE_DETAILS',
  CAMPAIGN_LIST = 'CAMPAIGN_LIST',
  CAMPAIGN_DETAILS = 'CAMPAIGN_DETAILS',
  PRICE_LIST = 'PRICE_LIST',
  CUSTOMER_SCREEN = 'CUSTOMER_SCREEN',
  BEAT_PLANS = 'BEAT_PLANS',
  DYNAMIC_SEGMENTS_LIST = 'DYNAMIC_SEGMENTS_LIST',
  AGENT_AUDIENCE = 'AGENT_AUDIENCE',
  ORDERS_WAITING_FOR_APPROVAL_LIST = 'ORDERS_WAITING_FOR_APPROVAL',
  DRAFT_ORDERS_LIST = 'DRAFT_ORDERS_LIST',
  IMPORTED_ORDERS_LIST = 'IMPORTED_ORDERS_LIST',
  PRICE_LIST_CRITERIA_LIST = 'PRICE_LIST_CRITERIA_LIST',
  GROW_CONVERSATION_LIST = 'GROW_CONVERSATION_LIST',
  DRAFT_LIST = 'DRAFT_LIST',
  GROW_DASHBOARD_FUNNELS = 'GROW',
}

export interface ISort {
  sortBy: string;
  sortDirection: string;
}

export interface DateRange {
  startDate: string;
  endDate: string;
}

export interface FilterValueObject {
  id: string;
  value: string;
}

export type AppliedFilters = {
  [filterLabel: string]: string[] | FilterValueObject[] | string | boolean;
};

export interface UserPreferenceDetail {
  pageSize?: number;
  pageNo?: number;
  sort?: ISort;
  appliedFilters?: AppliedFilters;
  dateRange?: DateRange;
  selectedTab?: string;
  additionalColumns?: ColumnKey[];
  lastVisitedPath?: string;
  pinnedFunnel?: string;
}

type ScreenPreference = {
  screenName: ScreenNameEnums;
} & UserPreferenceDetail;

export interface UpdateUserViewPreferenceRequest {
  sellerWorkspaceId: string;
  preference: ScreenPreference[];
}

export interface GetUserViewPreferenceRequest {
  sellerWorkspaceId: string;
  screenName: ScreenNameEnums;
}

export interface GetUserViewPreferenceResponse {
  preference: ScreenPreference;
  screenName: ScreenNameEnums;
  inviteId: string;
}
